export const money = (v, opts = {}) => {
  if (v === null || v === undefined) return '—';
  const n = Number(v) || 0;
  if (opts.compact && Math.abs(n) >= 10000) return `$${(n / 1000).toFixed(n >= 100000 ? 0 : 1)}k`;
  return n.toLocaleString('en-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: opts.cents ? 2 : 0 });
};
export const hrs = (v) => (v === null || v === undefined ? '—' : `${Number(v) % 1 === 0 ? Number(v) : Number(v).toFixed(1)}h`);
export const fmtDate = (s) => {
  if (!s) return '—';
  const d = new Date(`${String(s).slice(0, 10)}T12:00:00`);
  return isNaN(d) ? s : d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric' });
};
export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString('en-CA', { hour: 'numeric', minute: '2-digit' }) : '—');
export const daysUntil = (s) => {
  if (!s) return null;
  const d = new Date(`${String(s).slice(0, 10)}T12:00:00`);
  const t = new Date(); t.setHours(12, 0, 0, 0);
  return Math.round((d - t) / 86400000);
};

export const FLAG_META = {
  working_now: { label: 'On the floor now', cls: 'bg-emerald-500 text-white' },
  late: { label: 'Past due', cls: 'bg-rose-600 text-white' },
  due_soon: { label: 'Due this week', cls: 'bg-amber-100 text-amber-800 border border-amber-300' },
  over_budget: { label: 'Over job value', cls: 'bg-rose-100 text-rose-700 border border-rose-300' },
  budget_80: { label: '80%+ of value spent', cls: 'bg-amber-100 text-amber-800 border border-amber-300' },
  over_estimate: { label: 'Over estimated hours', cls: 'bg-rose-100 text-rose-700 border border-rose-300' },
  stale: { label: 'No hours in 7+ days', cls: 'bg-slate-200 text-slate-700' },
  waiting: { label: 'Waiting', cls: 'bg-purple-100 text-purple-700 border border-purple-200' },
  rate_missing: { label: 'Pay rate missing', cls: 'bg-slate-100 text-slate-500 border border-dashed border-slate-300' },
};

export const STATUS_PILL = {
  quoted: 'bg-slate-100 text-slate-600 border-slate-200',
  awarded: 'bg-blue-50 text-blue-700 border-blue-200',
  waiting_for_drawings: 'bg-purple-50 text-purple-700 border-purple-200',
  waiting_for_material: 'bg-purple-50 text-purple-700 border-purple-200',
  ready_for_scheduling: 'bg-sky-50 text-sky-700 border-sky-200',
  scheduled: 'bg-sky-50 text-sky-700 border-sky-200',
  in_progress: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  on_hold: 'bg-amber-50 text-amber-800 border-amber-300',
  ready_for_inspection: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  ready_for_shipping: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  completed: 'bg-slate-100 text-slate-500 border-slate-200',
};

export const PRIORITY_PILL = {
  emergency: 'bg-rose-600 text-white', rush: 'bg-orange-600 text-white', high: 'bg-amber-100 text-amber-800 border border-amber-300',
};

export const barColor = (pct) => (pct === null || pct === undefined ? 'bg-slate-300' : pct > 100 ? 'bg-rose-500' : pct > 80 ? 'bg-amber-500' : 'bg-emerald-500');

// Milestones derived from the Fab Scheduler card (status index + drawing/material flags).
export const MILESTONES = [
  { key: 'awarded', label: 'Awarded', done: (p) => p.status_index >= 1 },
  { key: 'drawings', label: 'Drawings', done: (p) => p.drawing_status === 'ready', blocked: (p) => p.status === 'waiting_for_drawings' },
  { key: 'material', label: 'Material', done: (p) => p.material_status === 'ready', blocked: (p) => p.status === 'waiting_for_material' },
  { key: 'scheduled', label: 'Scheduled', done: (p) => p.status_index >= 5, date: (p) => p.planned_start_date },
  { key: 'in_progress', label: 'In progress', done: (p) => p.status_index >= 6 || (p.actual_hours || 0) > 0 },
  { key: 'inspection', label: 'Inspection', done: (p) => p.status_index >= 8 },
  { key: 'shipping', label: 'Shipping', done: (p) => p.status_index >= 9 },
  { key: 'complete', label: 'Complete', done: (p) => p.status_index >= 10, date: (p) => p.required_completion_date },
];

export const milestoneStates = (p) => {
  let currentFound = false;
  return MILESTONES.map((m) => {
    const done = m.done(p);
    const blocked = !done && m.blocked?.(p);
    let state = done ? 'done' : 'todo';
    if (!done && !currentFound) { state = blocked ? 'blocked' : 'current'; currentFound = true; }
    return { key: m.key, label: m.label, state, date: m.date?.(p) || null };
  });
};
